import React from 'react';
import type { FC } from 'react';

interface ImportantUpdateProps {
    heading: string;
    body: string;
    learnMoreText?: string;
    learnMoreUrl?: string;
}

const ImportantUpdate: FC<ImportantUpdateProps> = ({
    heading,
    body,
    learnMoreText,
    learnMoreUrl,
}) => (
    <div className="important-update" role="note" aria-label="Important update">
        <div className="important-update__content">
            <b className="important-update__heading">{heading}</b>
            <p className="important-update__body">{body}</p>
            {learnMoreText && learnMoreUrl && (() => {
                const safePrefixes = ['https://', 'http://'];
                const isSafeUrl = safePrefixes.some((p) => learnMoreUrl.startsWith(p));
                return isSafeUrl ? (
                    <a className="important-update__link" href={learnMoreUrl} target="_blank" rel="noreferrer">
                        {learnMoreText}
                    </a>
                ) : null;
            })()}
        </div>
    </div>
);

ImportantUpdate.defaultProps = {
    learnMoreText: undefined,
    learnMoreUrl: undefined,
};

export default ImportantUpdate;
